import { useEffect, useState } from "react";
import { useCountry } from "@hooks/useCountry";
import Cookies from "js-cookie";

/** Hook to determine if user preferred SG edition or not. */
export const usePreferredEdition = () => {
  const { isSGUser } = useCountry();
  const [isSgPreferred, setIsSgPreferred] = useState<boolean>(true);

  const handleSG = () => {
    if (typeof window === "undefined") return;

    Cookies.set("preferred_region", "SG");
  };

  const handleNONSG = () => {
    if (typeof window === "undefined") return;

    Cookies.set("preferred_region", "NONSG");
  };

  useEffect(() => {
    if (typeof window === "undefined") return;

    const userPreferredVersion = Cookies.get("preferred_region");

    if (isSGUser && typeof userPreferredVersion === "undefined") return;
    if (userPreferredVersion === "SG") return;

    setIsSgPreferred(false);
  }, [isSGUser]);

  return { isSgPreferred, handleSG, handleNONSG };
};
